module.exports = __webpack_public_path__ + "static/media/sns.a22b10b6.jpg";